import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { Configs } from '@anm/hosting-player';

import { ControlsList, ControlType } from '.';

const getDefaultValue = (type: ControlType) => {
  switch (type) {
    case 'checkbox':
      return false;

    case 'color':
      return DEFAULT_WAVE_COLOR;

    case 'select':
      return '';
  }
};

export const getControlValue = (
  id: ControlsList,
  type: ControlType,
  initialConfigs: Configs
) => {
  try {
    const { playbar, ...commonConfigs } = initialConfigs;

    const extractedObj = {
      ...playbar,
      ...commonConfigs
    };

    return extractedObj[id] !== undefined
      ? extractedObj[id]
      : getDefaultValue(type);
  } catch (err) {
    console.error(err);
    return getDefaultValue(type);
  }
};
